import { defineMessages } from 'react-intl';

const messages: {
	updatePromptHint: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updatePromptHint: {
		id: 'ai-mate.conversation-assistant.store-human.inline-edit.updatePromptHint',
		defaultMessage: 'Rovo will rewrite its response based on your update.',
		description:
			'Hint text shown beneath the inline-edit textarea explaining that updating the prompt will trigger a fresh assistant reply.',
	},
	cancelLabel: {
		id: 'ai-mate.conversation-assistant.store-human.inline-edit.cancelLabel',
		defaultMessage: 'Cancel',
		description: 'Label for the inline-edit cancel button.',
	},
	updateLabel: {
		id: 'ai-mate.conversation-assistant.store-human.inline-edit.updateLabel',
		defaultMessage: 'Update',
		description: 'Label for the inline-edit update (submit) button.',
	},
});

export default messages;
